import * as v from "valibot";

export const OperationTypeEnum = v.picklist(["Pause", "Resume", "Cancel"]);
export type OperationType = v.InferOutput<typeof OperationTypeEnum>;

// request
export const RequestSchema = v.object({
  NodePoolId: v.string(),
  NodePoolActivityId: v.string(),
  OperationType: OperationTypeEnum,
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const DataSchema = v.object({
  NodePoolId: v.string(),
  NodePoolActivityId: v.string(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
